<template lang="">
  <div>
    <div
      class="grid grid-cols-1 xl:grid-cols-2 px-8 py-10 cursor-pointer border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl mb-4"
    >
      <div class="w-1/2 flex inline-flex items-center">
        <table class="popup-table">
          <tr>
            <th></th>
            <th></th>
            <th>Icon</th>
            <th>Font</th>
          </tr>
          <tr>
            <td>
              <div class="column-name"><span>Target Present Site</span></div>
            </td>
            <td>
              <div class="column-option">
                <input-field type="date" v-model="target.target_1_date" />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_Icon"
                  v-model="target.target_1_icon_color"
                />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_font"
                  v-model="target.target_1_font_color"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="column-name"><span>Target TPM/AMD Date</span></div>
            </td>
            <td>
              <div class="column-option">
                <input-field type="date" v-model="target.target_2_date" />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_Icon"
                  v-model="target.target_2_icon_color"
                />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_font"
                  v-model="target.target_2_font_color"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="column-name">
                <span>Target Site Hand Over Date</span>
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field type="date" v-model="target.target_3_date" />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_Icon"
                  v-model="target.target_3_icon_color"
                />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_font"
                  v-model="target.target_3_font_color"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="w-1/2 flex inline-flex items-center xl:ml-2">
        <table class="popup-table">
          <tr class="hidden xl:contents">
            <th></th>
            <th></th>
            <th>Icon</th>
            <th>Font</th>
          </tr>
          <tr>
            <td>
              <div class="column-name"><span>Target 1st CIA Date</span></div>
            </td>
            <td>
              <div class="column-option">
                <input-field type="date" v-model="target.target_4_date" />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_Icon"
                  v-model="target.target_4_icon_color"
                />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_font"
                  v-model="target.target_4_font_color"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="column-name"><span>Target Approval Date</span></div>
            </td>
            <td>
              <div class="column-option">
                <input-field type="date" v-model="target.target_5_date" />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_Icon"
                  v-model="target.target_5_icon_color"
                />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_font"
                  v-model="target.target_5_font_color"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="column-name"><span>Target Grand Open Date</span></div>
            </td>
            <td>
              <div class="column-option">
                <input-field type="date" v-model="target.target_6_date" />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_Icon"
                  v-model="target.target_6_icon_color"
                />
              </div>
            </td>
            <td>
              <div class="column-option">
                <input-field
                  type="select"
                  :options="colors_font"
                  v-model="target.target_6_font_color"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
      <ValidationObserver ref="simpleRules" tag="form">
        <div class="w-1/2 flex inline-flex items-center">
          <table class="popup-table">
            <tr>
              <th></th>
              <th></th>
              <th>Icon</th>
              <th>Font</th>
            </tr>
            <tr>
              <td>
                <div class="column-name"><span>First Layout Date</span></div>
              </td>
              <td>
                <div class="column-option">
                  <input-field type="date" v-model="target.first_layout_date" />
                </div>
              </td>
              <td>
                <div class="column-option">
                  <input-field
                    type="select"
                    :options="colors_Icon"
                    v-model="target.first_layout_date_icon_color"
                  />
                </div>
              </td>
              <td>
                <div class="column-option">
                  <input-field
                    type="select"
                    :options="colors_font"
                    v-model="target.first_layout_date_font_color"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="column-name"><span>Mall Leasing</span></div>
              </td>
              <td>
                <div class="column-option">
                  <input-field
                    v-model="target.mall_leasing"
                    rules="numeric"
                    errorMessage="only number"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="column-name">
                  <span>Construction Progress</span>
                </div>
              </td>
              <td>
                <div class="column-option">
                  <input-field
                    v-model="target.construction_progress"
                    rules="numeric"
                    errorMessage="only number"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="column-name"><span>Mall Construction</span></div>
              </td>
              <td>
                <div class="column-option">
                  <input-field
                    v-model="target.mall_construction"
                    rules="numeric"
                    errorMessage="only number"
                  />
                </div>
              </td>
            </tr>
          </table>
        </div>
      </ValidationObserver>
      <div class="w-1/2 flex inline-flex items-center">
        <table class="popup-table">
          <tr>
            <td class="td-noted">
              <div class="column-name xl:w-32"><span>Noted</span></div>
            </td>
            <td>
              <div class="column-noted">
                <input-field type="textarea" v-model="target.noted" />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="btn-action flex justify-end">
      <vs-button color="secondary" @click.prevent="confirmEdit"
        >Confirm</vs-button
      >
      <vs-button
        color="white"
        text-color="#6D7588"
        @click="$emit('close', false)"
        >Cancel</vs-button
      >
    </div>
  </div>
</template>
<script>
import InputField from '@/components/input-field/InputField.vue'
import { ValidationObserver } from 'vee-validate'
export default {
  name: 'adjust-date',
  components: {
    InputField,
    ValidationObserver
  },
  data() {
    return {
      colors_font: ['Black', 'Gray', 'Red', 'Blue'],
      colors_Icon: ['White', 'Green', 'Yellow', 'Red'],
      target: {
        target_1_date: null,
        target_1_icon_color: null,
        target_1_font_color: null,
        target_2_date: null,
        target_2_icon_color: null,
        target_2_font_color: null,
        target_3_date: null,
        target_3_icon_color: null,
        target_3_font_color: null,
        target_4_date: null,
        target_4_icon_color: null,
        target_4_font_color: null,
        target_5_date: null,
        target_5_icon_color: null,
        target_5_font_color: null,
        target_6_date: null,
        target_6_icon_color: null,
        target_6_font_color: null,
        first_layout_date: null,
        first_layout_date_icon_color: null,
        first_layout_date_font_color: null,
        mall_leasing: null,
        construction_progress: null,
        mall_construction: null,
        noted: null
      }
    }
  },
  props: {
    isParam: {
      type: Object,
      defaule: {}
    },
    isRow: {
      type: Number,
      defaule: null
    },
    isProjectId: {
      type: Number,
      defaule: null
    }
  },
  methods: {
    async confirmEdit() {
      const success = await this.$refs.simpleRules.validate()
      if (success) {
        const data = {
          index: this.isRow,
          projectId: this.isProjectId,
          target: this.target
        }
        this.$emit('confirm', data)
      }
    }
  },
  watch: {
    isParam: {
      handler() {
        this.target = { ...this.isParam }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss">
table.popup-table {
  th {
    text-align: center;
  }

  .column-name {
    width: 15rem;
  }

  .column-name span {
    top: -8px;
    position: relative;
  }

  .column-option {
    width: 14rem;
  }

  .column-option div {
    width: auto;
  }

  .column-noted {
    width: 250%;
  }

  td.td-noted {
    vertical-align: top;
    top: 10px;
    position: relative;
    left: 5px;
  }

  .v-select {
    min-width: 14rem !important;
  }

  .vs-con-input {
    height: 3.5rem;
  }
  .input-field {
    margin-bottom: 0.5rem !important;
  }
}
</style>
